import React, { Children, cloneElement, isValidElement, MouseEvent, ReactNode, useContext } from 'react'

import { ModalCloseEvent, ModalContext } from './modal-provider.js'

export interface ModalTriggerProps {
    children: ReactNode
}

interface ModalTriggerChildProps {
    props: {
        onClick: (e: ModalCloseEvent) => void
    }
}

export const ModalTrigger = (props: ModalTriggerProps): JSX.Element | null => {
    const { open, id, close, isOpen } = useContext(ModalContext)

    const enhanceItem = (child: ReactNode): ReactNode => {
        if (!isValidElement(child)) {
            return null
        }

        if (isValidElement(child)) {
            return cloneElement(child, {
                // @ts-expect-error Unknown props
                onClick: (event: MouseEvent<HTMLElement>): void => {
                    event.preventDefault()

                    if (isOpen && close) {
                        close(event, (child as ModalTriggerChildProps).props.onClick)
                    } else if (open) {
                        open()
                    }
                },
                url: `#${id || ''}`,
            })
        }
    }

    const children = Children.map(props.children, enhanceItem.bind(this))
    const child = children?.length ? children[0] : null

    return child ? <>{Children.only(child)}</> : null
}
